import { formatDateTime } from '../../lib/format'

interface Props {
	times: string[]
	/** The selected snapshot time, or null for "latest". */
	value: string | null
	onChange(value: string | null): void
}

/** Steps through the times a chart's ranking changed. */
export function SnapshotSlider({ times, value, onChange }: Props) {
	if (times.length < 2) return null
	const index = value
		? Math.max(
				0,
				times.findLastIndex((t) => t <= value),
			)
		: times.length - 1
	return (
		<div className="row" style={{ flex: '1 1 320px' }}>
			<label className="muted small" htmlFor="snapshot-slider">
				Time travel
			</label>
			<input
				id="snapshot-slider"
				type="range"
				min={0}
				max={times.length - 1}
				value={index}
				onChange={(e) => {
					const i = Number(e.target.value)
					onChange(i === times.length - 1 ? null : times[i])
				}}
				style={{ flex: 1 }}
				aria-valuetext={formatDateTime(times[index])}
			/>
			<button type="button" disabled={value === null} onClick={() => onChange(null)}>
				Latest
			</button>
		</div>
	)
}
